import { DEFAULT_ACTIVE_PRESET_ID, DEFAULT_PRESETS } from '../presets/defaultPresets';
import { applyPresetToConfig } from '../presets/presetUtils';
import { loadPresetStorage } from '../presets/presetStorage';
import { DEFAULT_CANVAS_FORMAT_ID } from '../canvasFormats';

export const DEFAULT_FPS = 60;
export const PROJECT_STORAGE_KEY = 'lowerThirds.project.v1';
export const PROJECT_STORAGE_VERSION = 1;
export const DEFAULT_PEOPLE = [
  {
    id: 'person-1',
    name: 'John Doe',
    title: 'Creative Director',
    mirrored: false,
    genericTextByPresetId: {},
  },
];

export const BASE_CONFIG = {
  transitionInDuration: 1.2,
  stillDuration: 2,
  transitionOutDuration: 1.2,
  fadeInDuration: 0.6,
  fadeOutDuration: 0.6,
  transitionInType: 'slide-left',
  transitionOutType: 'slide-left',
  fadeInCurve: 'linear',
  fadeOutCurve: 'linear',
  fadeIn: true,
  fadeOut: true,
  backgroundMode: 'alpha',
  backgroundKeyColor: '#00FF00',
};

export const createInitialProjectState = () => {
  const storedPresets = loadPresetStorage();
  const allInitialPresets = [...DEFAULT_PRESETS, ...storedPresets.customPresets];
  const activePreset = allInitialPresets.find((preset) => preset.id === storedPresets.activePresetId)
    || allInitialPresets.find((preset) => preset.id === DEFAULT_ACTIVE_PRESET_ID)
    || DEFAULT_PRESETS[0];
  const person = DEFAULT_PEOPLE[0];

  return {
    version: PROJECT_STORAGE_VERSION,
    revision: 1,
    updatedAt: Date.now(),
    people: [person],
    selectedPersonId: person.id,
    activePresetId: activePreset.id,
    customPresets: storedPresets.customPresets,
    config: applyPresetToConfig({ ...BASE_CONFIG }, activePreset),
    aspectRatioId: DEFAULT_CANVAS_FORMAT_ID,
    fps: DEFAULT_FPS,
  };
};
